import React from 'react';
import {Icon, faClipboard} from '@netx/core-icons';
import {Button} from '@mui/material';
import {TextField, type TextFieldProps} from '@netx/core-components/TextField';
import {styled} from '@netx/core-components/Theme';
import {Tooltip} from '@netx/core-components/Tooltip';
import {useCopyToClipboard} from '@netx/core-components/hooks/useCopyToClipboard';
import {CLIPBOARD_TEXT_FIELD_ACTION_LABEL} from './locales';

// TODO: this is only styled for outlined variant inputs atm
const ClipboardTextFieldAdornment = styled(Button)(({theme}) => ({
	marginRight: -13,
	height: 38,
	borderRadius: '0 3px 3px 0',
	padding: theme.spacing(0, 2),
	minWidth: 0,
	marginLeft: theme.spacing(1),
	'& svg': {
		fontSize: 16,
	},
}));

const ClipboardTextFieldRoot = styled(TextField)(({theme}) => ({}));

export interface ClipboardTextFieldProps extends Omit<
	TextFieldProps,
	'readOnly' | 'onChange'
> {
	copyErrorMessage?: string;
	copySuccessMessage?: string;
	value?: string | null;
}

export const ClipboardTextFieldPrimitive = (
	{
		copyErrorMessage,
		copySuccessMessage,
		value,
		...props
	}: ClipboardTextFieldProps,
	ref: React.ForwardedRef<HTMLDivElement>,
) => {
	const copyToClipboard = useCopyToClipboard({
		useSnackbar: true,
		snackbarErrorMessage: copyErrorMessage,
		snackbarSuccessMessage: copySuccessMessage,
	});

	return (
		<ClipboardTextFieldRoot
			{...props}
			ref={ref}
			readOnly
			value={value}
			InputProps={{
				...props.InputProps,
				endAdornment: (
					<Tooltip title={CLIPBOARD_TEXT_FIELD_ACTION_LABEL.COPY}>
						<ClipboardTextFieldAdornment
							data-testid="clipboard-copy-button"
							onClick={() => copyToClipboard(value || '')}
							aria-label={CLIPBOARD_TEXT_FIELD_ACTION_LABEL.COPY}
							color="primary"
							variant="contained"
							disableElevation
							style={{
								// can you say "hacky"?
								alignSelf: props.multiline ? 'stretch' : undefined,
								marginRight: props.multiline ? -13 : undefined,
								marginTop: props.multiline ? -8 : undefined,
								marginBottom: props.multiline ? -8 : undefined,
								height: props.multiline ? 'auto' : undefined,
							}}
						>
							<Icon icon={faClipboard} />
						</ClipboardTextFieldAdornment>
					</Tooltip>
				),
			}}
		/>
	);
};

export const ClipboardTextField = React.forwardRef(
	ClipboardTextFieldPrimitive,
) as (props: ClipboardTextFieldProps) => JSX.Element;

export default ClipboardTextField;
